<section class="curation-editor-wrapper curation-editor-placement" *ngIf="isDataLoaded">
  <gen-overlay-loader *ngIf="loading" class="curation-editor-overlay-loader"></gen-overlay-loader>
  <gen-curation-editor-header
    [curationItem]="curationItem"
    [curationStatus]="curationStatus"
    [revisionsData$]="revisionsData"
    [revisionName]="currentRevisionName"
    [readOnlyUserMode]="readOnlyUserMode"
    (revisionSelected)="revisionHistoryRowClick($event)"
    [revisionLastUpdatedDate]="revisionLastUpdatedDate"
    [lastManualOpinionName]="lastManualOpinionName"
  >
  </gen-curation-editor-header>
  <gen-curation-editor-actions
    [curationStatus]="curationStatus"
    [curationKey]="curationKey"
    [approvalUserMode]="approvalUserMode"
    [curatorUserMode]="curatorUserMode"
    [isAssignee]="isCurationItemAssignedToCurrentUser"
    [buttonsDisabled]="actionsDisabledMode"
    [publishUserMode]="publishUserMode"
    [curationItem]="curationItem"
    [oldRevisionMessage]="oldRevisionMessage"
    [readOnlyUserMode]="readOnlyUserMode"
    [multiStepReview]="multiStepReview"
    [revisedRelatedEntities]="revisedRelatedEntities"
    [newNotes]="newNotes"
    [reassignButtonDisabled]="isReassignButtonDisabled"
    [historyData]="revisionsData"
    (statusChanged)="changeStatus($event.status)"
    (statusChangedToRejected)="reject()"
    (goBackEvent)="goBack(true)"
    (notesPanelToggled)="toggleNotesPanel()"
    (toggleReassignCurationItem)="reassignCurationItem()"
    (toggleSubmitCurationItemForReview)="submitCurationItemForReview()"
    [sameOrganization]="sameOrganization"
    [showStopWorkflowButton]="showStopWorkflowButton"
    [showArchiveReason]="showArchiveReason"
    (toggleShowArchiveReason)="viewArchiveReason()"
  >
  </gen-curation-editor-actions>
  <gen-panel
    name="CURATION-NOTES-PANEL"
    class="{{notesPanelClass}}"
    (toggleDisplayStatusChanged)="toggleDisplayStatusChanged($event)">
  </gen-panel>
  <section *ngIf="!showBpmnModeler" class="scrollable">
    <section class="curation-editor-content" [ngClass]="curationStatus" *ngIf="isDataLoaded">
      <span class="titles">Placement Details</span>
      <gen-dynamic-form
        [listenToDataChange]="true"
        [formData]="formData"
        [formName]="formName"
        [formVertical]="true"
        [updateOnBlur]="false"
        [updatedFieldsContext]="updatedFieldsContext"
        [submitted]="submitted"
        [editMode]="true"
        [disabled]="readOnlyMode"
        (formChange)="updateForm($event.form, $event.updated)"
        [disabledFields]="disabledField"
        (validateChange)="validationEvent($event)"
        [additionalSearchValues]="revisedEntitiesRevisionsData">
      </gen-dynamic-form>
    </section>
  </section>

  <div *ngIf="showBpmnModeler && showTreeViewContainer" class="tree-view-icon-container"  id="treeViewIconContainer">
    <div class="view-icon-container"  [ngClass]=" explorerViewIsVisible ? 'explorer-view-opened': 'explorer-view-closed'">
      <i [ngClass]="explorerViewIsVisible ?'explorerview__icon__DLS_NetworkConnection_24': 'explorerview__icon__DLS_NetworkConnection_24_grey'"
         class="tree-view-icons-24"
         (click)="toggleTreeViewerPanel()"></i>
    </div>
  </div>

  <section *ngIf="showBpmnModeler" class="modeler-scrollable curation-editor-content-and-viewer">
    <section class="pathways-creator-container" *ngIf="isPathwayDataLoaded">
      <gen-panel class="tree-view-panel" [name]="bpmnTreeViewPanel"
                 [position]="bpmnTreeViewPanelPosition" [panelId]="'explorerView'"
                 (toggleDisplayStatusChanged)="explorerViewDisplayStatusChanged($event)"
                 [fullHeight]="true">
      </gen-panel>
      <ispm-modeler *ngIf="modelerVisible"
                    [headNodeName]="pathwayBpmnCurationData.content.pathwayBpmnName"
                    [data]="pathwayBpmnCurationData.content.bpmn"
                    [knowledgeBase]="getDbName()"
                    [config]="pathwayBpmnModelerCfg"
                    [state]="pathwayBpmnState"
                    [performTreeRepair]="pathwayPerformTreeRepair"
                    [revisedEntitiesRevisionsData]="revisedEntitiesRevisionsData"
                    [hideBpmnLogo]="hideBpmnLogo"
                    [discipline]="pathwayBpmnDiscipline"
                    (modelerRendered)="onModelerRender($event)"
                    (nodeDataUpdated)="onPlacementUpdated($event)"
                    (nodeSelected)="onNodeSelected($event)"
                    [panelOpenReadOnly]="isReadOnlyMode()"
                    (toggleRightPanel)="onRightPanelOpened($event)"
                    [useSideBarComponent]="true"
                    [clearNodeDataOnNodeUnSelection]="true"
                    [globalNotificationClass]="globalNotificationClass"
                    (toggleRightSidebar)="onRightSidebarOpened($event)"
      ></ispm-modeler>
    </section>
  </section>
</section>

<ng-template let-messageContainer #messageTemplate>
  <div class="pt-notification-item-content">
    <dls-icon [ngClass]="'icon-dls-info pt-icon ng-star-inserted'">
    </dls-icon>
    <div id="automation-placement-notification-title"
         [ngClass]="'pt-placement-notification-title'"
         [innerHTML]="messageContainer.title">
    </div>
    <div id="automation-placement-notification-content"
         [ngClass]="'pt-placement-notification-content'"
         [innerHTML]="messageContainer.body">
    </div>
    <button dlsButton class="icon-dls-cross pt-icon"
            (click)="messageService.clearMessage(messageContainer)"></button>
  </div>
</ng-template>
